import { isHoneycombTileNumericData } from './is-honeycomb-tile-numeric-data.js';
import { HoneycombDatasetType } from '../context/honeycomb-dataset-type.context.js';
import { HoneycombTileData } from '../types/honeycomb.js';

/**
 * Determines the type of data of the honeycomb passed
 *
 * Assumes that data is a non-empty array
 *
 * @param data -
 */
export const getHoneycombDatasetType = (
  data: HoneycombTileData[],
): HoneycombDatasetType => {
  return isHoneycombTileNumericData(data[0]) ? 'numeric' : 'categorical';
};
